import { render, staticRenderFns } from "./ImportEmploymentCompleted.vue?vue&type=template&id=2981702a"
import script from "./ImportEmploymentCompleted.vue?vue&type=script&lang=js"
export * from "./ImportEmploymentCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports